import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { queryClient } from '../../../common/providers/query'
import { objectsApi } from '../api/objects.api'
import { ObjectItem } from '../types/object.types'

export const useGetObjects = () => {
  return useQuery([QueryKey.Objects], async () => {
    const response = await objectsApi.getObjects()

    return response.data
  })
}

export const useCreateObject = () => {
  return useMutation(
    (object: Omit<ObjectItem, 'id' | 'type' | 'createdAt' | 'updatedAt'>) => {
      return objectsApi.create(object)
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries([QueryKey.Objects])
      },
    },
  )
}

export const useUpdateObject = () => {
  return useMutation(
    (object: Omit<ObjectItem, 'type' | 'createdAt' | 'updatedAt'>) => {
      return objectsApi.update(object)
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries([QueryKey.Objects])
      },
    },
  )
}

export const useDeleteObject = () => {
  return useMutation(
    (id: number) => {
      return objectsApi.deleteObject(id)
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries([QueryKey.Objects])
      },
    },
  )
}
